import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { ApplicationAccessLog } from '@referrals/shared/models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ApplicationAccessLogService {
  private headers: HttpHeaders;
  private accessPointUrl: string;

  constructor(private config: ConfigService, private http: HttpClient) {
    this.headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
    });
    this.accessPointUrl = `${this.config.referralsApiUrl}/applicationaccesslogs`;
  }

  public getById(id: number): Observable<ApplicationAccessLog[]> {
    return this.http.get<ApplicationAccessLog[]>(
      this.accessPointUrl + '/' + id,
      {
        headers: this.headers,
      }
    );
  }
}
